import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routers'
import store from '@/store'
import { setToken, getToken, canTurnTo } from '@/libs/util'
import ViewUIPlus from 'view-ui-plus'
const { VUE_APP_HOME_NAME } = process.env


const router = createRouter({
  routes,
  history: createWebHashHistory(),
  scrollBehavior() {
    return { top: 0 }
  }
})

const LOGIN_PAGE_NAME = 'login'
const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
  else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
}

router.beforeEach((to, from, next) => {
   ViewUIPlus.LoadingBar.start()
  const token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: VUE_APP_HOME_NAME 
    })
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next)
    } else {
      if (token) {
        next()
    } else {
      setToken('')
      next({
        name: 'login'
      })
    }
    }
  }
})

router.afterEach(to => {
  ViewUIPlus.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router

